import {
  keyToMediaCardType,
  MediaCardType,
  MediaString,
} from '@wandb/weave/common/types/media';
import {useCallback, useMemo} from 'react';

import {useKeyInfoQueryContext} from '../MultiRunWorkspace/KeyInfoQueryContext';
import {getMediaKeys} from './utils/getMediaKeys';

export const useGetMediaCardType = (
  mediaKeys: string[] | undefined
): (() => MediaCardType | null) => {
  const {
    keyInfoQuery: {historyKeyInfo: keyInfo},
  } = useKeyInfoQueryContext();
  return useCallback(() => {
    const {keyTypes} = getMediaKeys(keyInfo);
    const firstMediaKey = mediaKeys?.[0] ?? null;
    const mediaString =
      firstMediaKey != null ? (keyTypes[firstMediaKey] as MediaString) : null;
    return mediaString != null &&
      mediaString !== 'data-frame' &&
      mediaString !== 'media'
      ? keyToMediaCardType(mediaString)
      : null;
  }, [mediaKeys, keyInfo]);
};

export const useMediaCardType = (mediaKeys: string[] | undefined) => {
  const getMediaCardType = useGetMediaCardType(mediaKeys);
  return useMemo(() => getMediaCardType(), [getMediaCardType]);
};
